import { AirportSearchViewModel } from '@api/index';
import CustomIcon from '@components/utils/CustomIcon';
import { LocationIcon, PlaneIcon } from '@assets/icons';
import { FlexibleDiv } from '@components/formStyles';
import { AirportSearchResultListProps } from '@components/views/flight/types';
import {
  getAirportListItemTitleText,
  getAirportListItemSubTitleText,
} from '@components/views/flight/utils';
import {
  ItemText,
  ItemTextWrapper,
} from '@components/ui/search/SearchResultListStyle';

import {
  AirportCity,
  AirportList,
  AirportListItem,
} from './SearchBarAirportSearchStyle';

const AirportSearchResultList = ({
  onSelect,
  data,
}: AirportSearchResultListProps) => {
  return data.length ? (
    <AirportList
      dataSource={data}
      renderItem={(item: AirportSearchViewModel) => (
        <AirportListItem onClick={() => onSelect(item)}>
          <CustomIcon
            width={24}
            height={24}
            fontSize={24}
            paletteColor='brownishGrey'
            icon={item.isCity ? LocationIcon : PlaneIcon}
          />
          <FlexibleDiv right={17} />
          <ItemTextWrapper>
            <ItemText>
              <AirportCity>{getAirportListItemTitleText(item)}</AirportCity>
            </ItemText>
            <AirportCity>{getAirportListItemSubTitleText(item)}</AirportCity>
          </ItemTextWrapper>
        </AirportListItem>
      )}
    />
  ) : null;
};

export default AirportSearchResultList;
